{
  "es": {
    "paginator": {
      "labels": {
        "perPage": "Per Page",
        "pages": "%{page} of %{total}"
      }
    }
  }
}
